import React from 'react';
import type { HeadingSizeKeys } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';

import * as styles from './SkeletonLabel.styles';

const headingFallbackHeights: Record<HeadingSizeKeys, number> = {
  XL: 28,
  LG: 24,
  MD: 20,
  SM: 18,
  XS: 16,
};

export interface SkeletonLabelProps {
  className?: string;
  height?: number;
  labelHeight?: HeadingSizeKeys;
  variant?: 'regular' | 'short';
}

export const SkeletonLabel = ({
  className,
  height,
  labelHeight = 'MD',
  variant = 'regular',
}: SkeletonLabelProps) => (
  <div
    className={className}
    css={styles[variant]}
    style={{
      height: pxToRem(height || headingFallbackHeights[labelHeight]),
    }}
  />
);
